import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment as env } from 'src/environments/environment';
import { HomeInstagramPayload, InstagramArticle } from 'src/app/models/home-instagram';

@Injectable({
  providedIn: 'root'
})
export class HomeInstagramService {
  private jsonUrl = 'https://s3-us-west-2.amazonaws.com/filesstaticpulzo/pulzo-lite/jsons/admin/instagram/instagram.json';
  private baseUrl = `${env.apiCerberoUrl}`;

  //prefijo base para imágenes antiguas
  private imageBaseUrl = 'https://d2yoo3qu6vrk5d.cloudfront.net/pulzo-lite/RedaccionApp/';

  constructor(private http: HttpClient) {}

  normalizarImagen(image: string): string {
    if (!image) return '';
    if (image.startsWith('http')) {
      return image; // ya es URL completa
    }
    return `${this.imageBaseUrl}${image}`;
  }

  async listarInstagram(): Promise<{ instagram: InstagramArticle[] }> {
    try {
      const random = Date.now();
      const url = `${this.jsonUrl}?nocache=${random}`; 
      const response = await fetch(url);
  
      if (!response.ok) throw new Error('Error al cargar el JSON de Instagram');
      const data = await response.json();
  
      if (data?.instagram?.length) {
        data.instagram = data.instagram.map((item: InstagramArticle) => ({
          ...item,
          image: this.normalizarImagen(item.image)
        }));
      }
  
      return data;
    } catch (error) {
      console.error('Error en listarInstagram:', error);
      throw error;
    }
  }
  

  async obtenerArticuloPorId(id: string): Promise<any> {
    const url = `https://s3-us-west-2.amazonaws.com/filesstaticpulzo/pulzo-lite/posts/${id}.json`;
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Error al cargar el artículo con id ' + id);
      const articulo = await response.json();

      return {
        ...articulo,
        image: this.normalizarImagen(articulo.image || articulo.Image)
      };
    } catch (error) {
      console.error('Error en obtenerArticuloPorId:', error);
      throw error;
    }
  }

  actualizarHomeInstagram(data: HomeInstagramPayload): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/request?event=actualizar-home-instagram`,data);
  }

  uploadImage(formData: FormData): Promise<any> {
    return this.http.post(`${this.baseUrl}/upload-file`, formData).toPromise();
  }
  
  
}
